import Warning from "@/assets/icon/Warning";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from "@mui/material";
import { forwardRef } from "react";
import Label from "../Label/Label";
import Info from "@/assets/icon/Info";
import Failed from "@/assets/icon/Failed";
import { useAlertDialog } from "@/useHooks/Dialog/useAlertDialog";


const AlertDialog = forwardRef<HTMLDivElement>((_, ref) => {
  const { dialogState, dismissDialog } = useAlertDialog();
  const { isOpen, type, title, message, onConfirm, onCancel } = dialogState;


  const handleClose = () => {
    if (onCancel) onCancel();
    dismissDialog();
  };

  const iconMap = {
    info: <Info color="info" />,
    warning: <Warning color="warning" />,
    error: <Failed color="error" />,
    normal:<></>
  };

  const titleContent = (
    <Stack spacing={2} direction="row" alignItems="center">
      {iconMap[type]}
      <Label id={title} />
    </Stack>
  );

  return (
    <Dialog
      ref={ref}
      fullWidth
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {type === "normal" ? <Label id={title} /> : titleContent}
      </DialogTitle>

      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Stack direction="row" spacing={2}>
          <Button onClick={handleClose}>
            <Label id={["normal", "info", "error"].includes(type) ? "BTN_CONFIRM" : "BTN_CANCEL"} />
          </Button>
          {type === "warning" && (
            <Button
              onClick={() => {
                if (onConfirm) onConfirm();
                dismissDialog();
              }}
              autoFocus
            >
              <Label id={"BTN_AGREE"} />
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
});

export default AlertDialog;